module.exports = __webpack_public_path__ + "img/selected6-min.700ee2c1.png";